import { GetInTouch } from '@components/get-in-touch'
import { useGetInTouchContext } from '@components/get-in-touch/Context'
import { Page } from '@components/page'
import { Seo } from '@components/Seo'
import { Hero } from '@components/_about-us/hero'
import { MeetTheTeam } from '@components/_about-us/meet-the-team'
import { OurStory } from '@components/_about-us/our-story'
import { UspBlocks } from '@components/_about-us/usp-blocks'
import { getSanityClient } from '@lib/sanity/client'
import { GetStaticProps } from 'next'
import React, { FC } from 'react'
import { AboutUsSingleton } from '__generated__/sanity'

type AboutUsProps = {
  pageContent: AboutUsSingleton
}

const AboutUs: FC<AboutUsProps> = ({ pageContent }) => {
  const { isVisible } = useGetInTouchContext()
  return (
    <Page>
      <Seo data={pageContent.fields.seo} />
      {isVisible && <GetInTouch />}
      <Hero {...pageContent.fields.hero} />
      <OurStory {...pageContent.fields.ourStory} />
      <UspBlocks {...pageContent.fields.uspBlocks} />
      <MeetTheTeam {...pageContent.fields.meetTheTeam} />
    </Page>
  )
}

export const getStaticProps: GetStaticProps<AboutUsProps> = async ({ preview = false }) => {
  const sanity = getSanityClient(preview)
  const query = `*[_type == "about-us-singleton"]`
  const queryResult = await sanity.fetch(query)
  const draft = queryResult.find((item) => item._id.startsWith('drafts.'))
  const content = preview ? draft || queryResult[0] : queryResult[0]

  return {
    props: {
      pageContent: content as AboutUsSingleton,
    },
  }
}

export default AboutUs
